import { X, Mail, Loader2 } from "lucide-react";
import { Field } from "@/components/UI";

export const EmailModal = ({ emailModal, setEmailModal, sendEmail }) => {
  if (!emailModal.open) return null;
  const close = () => setEmailModal({ open: false, doc: null, to: "", message: "", sending: false });
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="email-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5 space-y-4">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-bold text-base">Send to client</h3>
            <p className="text-xs muted mt-0.5">
              {emailModal.doc?.serial} · signed &amp; stamped PDF attached
              {emailModal.doc?.doc_type === "quotation" && (
                <> · includes a one-click <b>Accept</b> link</>
              )}
            </p>
          </div>
          <button onClick={close} className="text-slate-400 hover:text-slate-600" data-testid="email-modal-close">
            <X size={16} />
          </button>
        </div>
        <Field label="To (client email) *">
          <input
            data-testid="email-to"
            className="input"
            type="email"
            value={emailModal.to}
            onChange={(e) => setEmailModal((m) => ({ ...m, to: e.target.value }))}
            placeholder="client@company.com"
          />
        </Field>
        <Field label="Message (optional — a polite default is used if empty)">
          <textarea
            data-testid="email-message"
            className="input"
            rows={4}
            value={emailModal.message}
            onChange={(e) => setEmailModal((m) => ({ ...m, message: e.target.value }))}
            placeholder="Dear customer, please find attached…"
          />
        </Field>
        <div className="flex justify-end gap-2">
          <button className="btn btn-ghost" onClick={close} data-testid="email-cancel">
            Cancel
          </button>
          <button className="btn btn-primary" onClick={sendEmail} disabled={emailModal.sending} data-testid="email-send">
            {emailModal.sending ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />}
            {emailModal.sending ? "Sending…" : "Send PDF"}
          </button>
        </div>
      </div>
    </div>
  );
};
